export default __webpack_public_path__ + "static/media/logo.46ae6750.svg";